import React from 'react';
import { Col, Image, Row, Typography, Upload } from 'antd';
import { LoadingOutlined, PlusCircleFilled } from '@ant-design/icons';

import { formatCnpj, formatCpf, beforeUpload } from '@utils/index';

import { useRepresentative } from '@hooks/RepresentativeContext';
import Loading from '@components/Loading';

import * as S from './styles';

const { Title } = Typography;

const ProfileInformation: React.FC = () => {
  const { actualRepresentative, loadingImageUpload, updateImage } = useRepresentative();

  const getUploadContent = () => {
    if (actualRepresentative.photoUrl)
      return (
        <Image
          src={actualRepresentative.photoUrl}
          style={{ width: '100%', maxHeight: '100px', borderRadius: '8px', marginTop: '8px' }}
          preview={false}
          fallback="data:image/png;base64,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"
        />
      );

    if (loadingImageUpload)
      return (
        <S.LoadingContainer>
          <LoadingOutlined style={{ color: 'var(--primary-color)' }} />
        </S.LoadingContainer>
      );

    return (
      <S.UploadBody>
        <PlusCircleFilled style={{ color: 'var(--primary-color)' }} />
        <h5>Adicionar um logo</h5>
      </S.UploadBody>
    );
  };

  const handleUpload = ({ file }: any) => {
    if (!file) return;

    updateImage(actualRepresentative.code, file);
  };

  if (!actualRepresentative) return <Loading />;

  return (
    <>
      <Row className="mt-4">
        <Col className="d-flex" span={24}>
          <S.ProfileContainer gutter={[48, 8]}>
            <S.InfoContainer
              className="d-flex ml-4 gutter-row"
              style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}
            >
              <div>
                <Upload showUploadList={false} beforeUpload={beforeUpload} customRequest={handleUpload}>
                  {getUploadContent()}
                </Upload>
              </div>

              <div className="ml-4 d-flex" style={{ flexDirection: 'column' }}>
                <Title level={5}>Representante Comercial</Title>
                <span>{actualRepresentative.name}</span>
                <span>#{actualRepresentative.code}</span>
              </div>
            </S.InfoContainer>

            {actualRepresentative.cpfCnpj && (
              <S.InfoContainer className="gutter-row">
                <Title level={5}>{actualRepresentative.cpfCnpj?.length > 11 ? 'CNPJ' : 'CPF'}</Title>
                <span>
                  {actualRepresentative.cpfCnpj?.length > 11
                    ? formatCnpj(actualRepresentative.cpfCnpj)
                    : formatCpf(actualRepresentative.cpfCnpj)}
                </span>
              </S.InfoContainer>
            )}

            {actualRepresentative.emails && actualRepresentative.emails?.length ? (
              <S.InfoContainer className="gutter-row">
                <Title level={5}>E-mail</Title>
                <span>{actualRepresentative.emails[0].email}</span>
              </S.InfoContainer>
            ) : null}

            {actualRepresentative.phones && actualRepresentative.phones?.length ? (
              <S.InfoContainer className="gutter-row">
                <Title level={5}>Nº Celular</Title>
                <span>{actualRepresentative.phones[0].number}</span>
              </S.InfoContainer>
            ) : null}
          </S.ProfileContainer>
        </Col>
      </Row>
    </>
  );
};

export default ProfileInformation;
